import React, {useEffect, useState} from 'react';
import {Button} from 'primereact/button';
import AuthService from '../../services/authService';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const AnttButton: React.FC<any> = ({permissao, children, color, faIcon, faIconPos, faIconStyle, faIconOpts, ...rest}) => {
  const authService = new AuthService();
  const auth = authService.getCurrentState();
  const [showButton, setShowButton] = useState(true);

  useEffect(() => {
    if (!permissao) {
      setShowButton(true);
      return;
    }
    setShowButton(authService.temPermissao(permissao));
  }, [auth]);
  const _children = () => {
    if (!faIcon) {
      return <>{children}</>;
    }
    const _icon = () => {
      return (
        <>
          <FontAwesomeIcon
            style={faIconStyle}
            icon={faIcon}
            size="sm"
            color={!!color ? color : '#686D71'}
            {...faIconOpts}
          />
        </>
      );
    };
    if (!faIconPos || faIconPos === 'left') {
      return (
        <>
          {_icon()}
          {children}
        </>
      );
    }
    return (
      <>
        {children}
        {_icon()}
      </>
    );
  }
  return <>{showButton && <Button type="button" {...rest}>{_children()}</Button>}</>;
};
export default AnttButton;
